import { ERolesCode } from "../../pages/routes/role-catalog";

export const isValidToChangeAssigned = (value: ERolesCode) => {
  return [
    ERolesCode.ADMINISTRATOR,
    ERolesCode.PARTNER,
    ERolesCode.SUPER_ADMIN,
  ].includes(value);
};
